var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTablet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.998 0A1 1 0 0 1 12 1v14c0 .552-.456 1-1.002 1H1.002A1 1 0 0 1 0 15V1c0-.552.456-1 1.002-1zM7 14H5v1h2zm4-12H1v11h10z"
})));
export default SvgTablet;